import React, { useState } from "react";
import "./forgotPassword.css";
import { useAuthContext } from "../../context/authContext";
import axios from "axios";
import { BaseUrl } from "../../Actions/Base";
import ReCAPTCHA from "react-google-recaptcha-v2";
import { GetLocalStorage } from "../../Helpers/LocalStorage/LocalStorage";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [captcha, setCaptcha] = useState();

  const {
    setForgotPass,
    setOtpPopup,
    setOtpEmail,
    changePassPopup,
    forgotPass,
    setChangePassPopup,
    setChangeOtpPopup
  } = useAuthContext();
  const [loading, setLoading] = useState(false);

  function onChangee(value) {
    setCaptcha(value);
  }

  const OnClickFun = () => {};

  let InputBoxStyle = `w-full rounded-[6px] outline-0 bg-[#F3F6F7] text-gray-400 h-[45px] border-[1px] border-solid
    text-4xs md:text-[16px]   lg:text-[16px]     xl:[16px]   
    py-[6px]                    xl:py-3
    px-[8px]                    xl:px-[22px]    2xl:px-7`;

  const axiosInstance = axios.create({
    baseURL: BaseUrl,
    withCredentials: true,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("in handle submit form click");
    console.log("in handle submit form forgotPass",forgotPass)
    console.log("in handle submit form email",email)

    if(forgotPass) {

      if (!captcha) {
        setCaptchaError("Please click the captcha to proceed!");
        return;
      } 
    }
// console.log("UserInfoooooo", GetLocalStorage("UserInfo"))
    const changePassEmail = GetLocalStorage("UserInfo")?.Email
    const payload = {
      Email: forgotPass ? email : changePassEmail,
    };
    try {
      setLoading(true);
      console.log("in handle submit form payload",payload)

      const res = await axiosInstance.post("/api/forgot-password", payload);
      console.log(res);
      if (res?.data?.success === true) {
        if(forgotPass) {

          setForgotPass(false);
          setOtpPopup(true);
        }else {
          setChangePassPopup(false)
          setChangeOtpPopup(true)
        }
        setOtpEmail(email);
        localStorage.setItem(
          "token",
          JSON.stringify(res?.data?.ResetPasswordToken)
        );
      } else if (res?.data?.success === false) {
      }

      setLoading(false);
    } catch (err) {
      console.log(err);
      setError(err?.response?.data?.message);
      setLoading(false);
    }
  };
  const handleClose = () => {
    if(forgotPass) {
      setForgotPass(false);
    }else {
      setChangePassPopup(false)
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 "
    style={{zIndex: '200000'}}
    >
      <form
        onSubmit={handleSubmit}
        className="BG_IMAGEE w-[80%] rounded-[24px]  bg-[#e1e7f0] py-10 px-10 text-white sm:w-[380px] sm:p-10 md:w-[686px] md:px-[4rem] 2xl:pb-14 3xl:pb-14"
      >
        <span
          onClick={handleClose}
          class="material-symbols-outlined absolute right-[1rem] top-[1rem] cursor-pointer font-semibold text-primary"
          style={{
            fontSize: "30px",
          }}
        >
          close
        </span>
        <div className="flex  w-full items-center justify-center">
          <img
            className="h-[40px] w-[220px]  md:h-[60px] md:w-[328px]"
            src={require("../Assets/forgotLog.png")}
            alt=""
          />
        </div>

        <div className="mt-[30px]  mb-[1rem] flex w-full flex-col items-center justify-center text-[#1D1D1D]">
          <h2 className="text-3xs font-bold md:text-xs 2xl:text-[24px]">
            {changePassPopup ? "Change Your Password" : "Forgot Password"}
          </h2>
          {forgotPass ? (
            <p className=" my-3 mt-3 text-center text-4xs font-semibold md:px-5 md:text-2xs ">
              Enter your email to reset your password
            </p>
          ) : null}
        </div>

        {error ? <h4 className="font-normal text-[red]"> {error} </h4> : null}

        {/* inputs */}
        {
          forgotPass ? <div>
          <span className="flex flex-col">
            <input
              id="EmailAddress"
              className={`${
                error ? "border-[red] " : "border-[#BCBCBC]"
              } ${InputBoxStyle} max-w-[650px ] `}
              type="email"
              placeholder="Email Address"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </span>
        </div> : null
        }
        

        {forgotPass ? (
          <div className="mt-4">
            {captchaError ? (
              <h4 className="font-normal text-[red]"> {captchaError} </h4>
            ) : null}
            <ReCAPTCHA
              // sitekey="6Lecb_IoAAAAANjflXMmXPZiBMaU0clxSmxPG9f9"
              sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_LIVE_KEY}
              onChange={onChangee}
            />
          </div>
        ) : null}

        <div className="">
          <span
            className={`submit-btn-box-shadow relative mt-8 flex w-full justify-center`}
          >
            <button
              className={`h-[45px] w-full cursor-pointer rounded-[8px] border-none bg-primary  py-2
                           text-[16px] text-white md:text-[18px]  xl:py-3 
                            xl:text-[18px]     `}
              type="submit"
              onClick={OnClickFun}
            >
              {forgotPass ? "Request a password reset" : "Click here to Change Your Password"}
              {loading ? (
                <span className="ml-4">
                  <svg
                    aria-hidden="true"
                    role="status"
                    class="me-3 inline h-5 w-5 animate-spin text-white"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              ) : null}
            </button>
          </span>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
